import { render, staticRenderFns } from "./mintroduction.vue?vue&type=template&id=88fd6498&scoped=true&"
import script from "./mintroduction.vue?vue&type=script&lang=js&"
export * from "./mintroduction.vue?vue&type=script&lang=js&"
import style0 from "./mintroduction.vue?vue&type=style&index=0&id=88fd6498&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88fd6498",
  null
  
)

export default component.exports